import Logger from "js-logger";
export default Logger;
